import axios from 'axios';
import { useEffect, useState } from 'react';

// axios.defaults.baseURL = 'https://famand.playoffinformatica.com/api.php/api/v1.0';

function App() {
    const [ clubs, setClubs ] = useState();
    const [ state, setState ] = useState();

    const [ search, setSearch ] = useState();

    const handleOnState = ({ target: { value } }) => setState(value);
    const handleOnSearch = ({ target: { value } }) => setSearch(value);

    const handleInit = () => {
        axios   .get('/wp-content/plugins/clubs-app/clubs.json')

                .then(response => response.data)
                .then(response => response.filter(club => club.estatClub == 'CLUBALT'))

                .then(response => response.map((club, i) => ({
                    name: club.nom,
                    address: club.adreces[0]?.domicili,
                    postal_code: club.adreces[0]?.codipostal,
                    phone: club.adreces[0]?.mobil,
                    email: club.adreces[0]?.email,
                    state: club.adreces[0]?.municipi.provincia.nom
                })))

                .then(setClubs);
    };

    useEffect(handleInit, []);

    return (
        <>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <div className="form-group">
                        <label htmlFor='provincia'>Filtrar por provincia:</label>

                        <select id='provincia' className='custom-select' onChange={ handleOnState }>
                            <option value=''>Seleccionar provincia...</option>

                            <option value='ALMERÍA'>ALMERÍA</option>
                            <option value='CÁDIZ'>CÁDIZ</option>
                            <option value='CÓRDOBA'>CÓRDOBA</option>
                            <option value='GRANADA'>GRANADA</option>
                            <option value='HUELVA'>HUELVA</option>
                            <option value='JAEN'>JAEN</option>
                            <option value='MÁLAGA'>MÁLAGA</option>
                            <option value='SEVILLA'>SEVILLA</option>
                        </select>
                    </div>
                </div>

                <div className='col-12 col-md-6'>
                    <div className="form-group">
                        <label htmlFor='nombre'>Buscar:</label>

                        <input id='nombre' type='text' className='form-control' onChange={ handleOnSearch } placeholder='Buscar...'/>
                    </div>
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>CLUB</th>
                        <th>DIRECCION</th>
                        <th>C. POST</th>
                        <th>TELEFONO</th>
                        <th>E-MAIL</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        // show if value has not value
                        // or filter by state
                        clubs   ? clubs?.filter(club => !state || club.state == state)
                                        .filter(club => {
                                            if(!search) {
                                                return true;
                                            }

                                            const pSearch = search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                                            const pClubName = club.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                                            return pClubName.indexOf(pSearch.toLowerCase()) > -1;
                                        })
                                        .map((club, i) => (
                                            <tr key={ i }>
                                                <td>{ i + 1 }</td>
                                                <td>{ club.name }</td>
                                                <td>{ club.address }</td>
                                                <td>{ club.postal_code }</td>
                                                <td>{ club.phone }</td>
                                                <td>{ club.email }</td>
                                            </tr>
                                        ))

                                : <p>Cargando...</p>
                    }
                </tbody>
            </table>
        </>
    );
}

export default App;
